import AppConstants from '../../Constants/AppConstants';

export const storageHubDraftKey = id =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:delivery:storage-hub:${id || 'new'}`;
export const readStorageHubDraft = key => {
  try {
    const draft = JSON.parse(window.localStorage.getItem(key) || '{}');
    return draft && typeof draft === 'object' ? draft : {};
  } catch (error) { return {}; }
};
export const writeStorageHubDraft = (key, state) => {
  const draft = {};
  ['name', 'phoneNumber', 'addressLine1', 'addressLine2', 'landmark', 'state', 'postCode', 'country'].forEach(field => {
    draft[field] = String(state[field] || '').slice(0, field === 'addressLine1' || field === 'addressLine2' ? 500 : 300);
  });
  try { window.localStorage.setItem(key, JSON.stringify(draft)); }
  catch (error) { /* Keep the editor usable when browser storage is unavailable. */ }
};
export const clearStorageHubDraft = key => {
  try { window.localStorage.removeItem(key); }
  catch (error) { /* Ignore storage errors after save or explicit discard. */ }
};
